'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

var _typeof3 = require('@babel/runtime/helpers/typeof');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports['default'] = renderSwitcherIcon;

var _typeof2 = _interopRequireDefault(require('@babel/runtime/helpers/typeof'));

var React = _interopRequireWildcard(require('react'));

var _classnames = _interopRequireDefault(require('classnames'));

var _LoadingOutlined = _interopRequireDefault(require('@ant-design/icons/LoadingOutlined'));

var _FileOutlined = _interopRequireDefault(require('@ant-design/icons/FileOutlined'));

var _MinusSquareOutlined = _interopRequireDefault(require('@ant-design/icons/MinusSquareOutlined'));

var _PlusSquareOutlined = _interopRequireDefault(require('@ant-design/icons/PlusSquareOutlined'));

var _CaretDownFilled = _interopRequireDefault(require('@ant-design/icons/CaretDownFilled'));

var _reactNode = require('antd/lib/_util/reactNode');

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (_typeof3(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj['default'] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function renderSwitcherIcon(prefixCls, switcherIcon, showLine, _ref) {
  var isLeaf = _ref.isLeaf,
    expanded = _ref.expanded,
    loading = _ref.loading;

  if (loading) {
    return /*#__PURE__*/ React.createElement(_LoadingOutlined['default'], {
      className: ''.concat(prefixCls, '-switcher-loading-icon'),
    });
  }

  var showLeafIcon;

  if (showLine && (0, _typeof2['default'])(showLine) === 'object') {
    showLeafIcon = showLine.showLeafIcon;
  }

  if (isLeaf) {
    if (showLine) {
      if ((0, _typeof2['default'])(showLine) === 'object' && !showLeafIcon) {
        return /*#__PURE__*/ React.createElement('span', {
          className: ''.concat(prefixCls, '-switcher-leaf-line'),
        });
      }

      return /*#__PURE__*/ React.createElement(_FileOutlined['default'], {
        className: ''.concat(prefixCls, '-switcher-line-icon'),
      });
    }

    return null;
  }

  var switcherCls = ''.concat(prefixCls, '-switcher-icon');

  if ((0, _reactNode.isValidElement)(switcherIcon)) {
    return (0, _reactNode.cloneElement)(switcherIcon, {
      className: (0, _classnames['default'])(switcherIcon.props.className || '', switcherCls),
    });
  }

  if (switcherIcon) {
    return switcherIcon;
  }

  if (showLine) {
    return expanded
      ? /*#__PURE__*/ React.createElement(_MinusSquareOutlined['default'], {
          className: ''.concat(prefixCls, '-switcher-line-icon'),
        })
      : /*#__PURE__*/ React.createElement(_PlusSquareOutlined['default'], {
          className: ''.concat(prefixCls, '-switcher-line-icon'),
        });
  }

  return /*#__PURE__*/ React.createElement(_CaretDownFilled['default'], {
    className: switcherCls,
  });
}
